<script setup lang="ts">

import TheIcon from '@/Components/TheIcon.vue'
import { vOnClickOutside } from '@vueuse/components'
import { SelectedOption, SortingOptions } from '@/Interfaces/AppSorting'

type Props = {
    options: SortingOptions,
    selected: SelectedOption
    sortingIsOpen: boolean
}

const props = defineProps<Props>()

const emit = defineEmits(['sortList', 'changeSortingIsOpen'])

</script>

<template>
    <div v-on-click-outside="() => emit('changeSortingIsOpen', false)" class="app-sorting">
        <button class="app-sorting-btn" @click=" emit('changeSortingIsOpen', !sortingIsOpen)">
            Sort by: <span class="text-capitalize">{{ selected.title }}</span>

            <TheIcon icon-id="arrow-bottom" width="24" height="24" />
        </button>

        <div
            v-if="sortingIsOpen"
            class="dropdown-menu p-3 show"
        >
            <ul class="mb-0 pl-0 list-unstyled">
                <template
                    v-for="(item) in options"
                    :key="`sortBy-${ item?.key }`"
                >
                    <li
                        class="py-2 border-bottom cursor-pointer d-flex justify-content-between"
                        @click="emit('sortList', item)"
                    >
                        {{ item.title }}

                        <TheIcon
                            v-if="selected.title === item.title"
                            icon-id="checked-icon"
                            width="24"
                            height="24"
                        />
                    </li>
                </template>
            </ul>
        </div>
    </div>
</template>

<style scoped lang="scss">
.app-sorting {
    position: relative;

    li {
        color: #787d8d;
        font-size: 14px;

        &.selected {
            color: #4a5268;
        }
    }

    .dropdown-menu {
        min-width: 240px;
        max-height: 200px;
        overflow-y: auto;

        right: 0;
        left: initial;
    }

    &-btn {
        border: none;
        background-color: transparent;
        color: #787D8D;
        display: flex;
        align-items: center;
        gap: 4px;
        font-size: 14px;
        font-weight: 400;
        line-height: 19px;

        span {
            font-size: 14px;
            font-weight: 400;
            line-height: 19px;
        }

        &:focus {
            outline: none;
        }
    }
}
</style>